/**
 * API error codes that are reported by regional API controllers (mainly configuration), for mapping to readable errors in web
 */
export var RealtimeRecorderErrorCode;
(function (RealtimeRecorderErrorCode) {
    /**
     * Indicates an attempt to enable a Real-Time Recorder for a location that already has a recorder enabled
     */
    RealtimeRecorderErrorCode["RecorderAlreadyEnabledForLocation"] = "realtime-recorder/RecorderAlreadyEnabledForLocation";
})(RealtimeRecorderErrorCode || (RealtimeRecorderErrorCode = {}));
